export default __webpack_public_path__ + "static/media/Emma.1a63a153.jpg";